<!-- 次级导航 -->
<template>
  <div class="subNavs" v-if="subNavs.length != 0">
    <div class="in w1200">
      <router-link :to="item.path" v-for="item in subNavs" :key="item.path">
        <div :class="{ nav: true, active: computedActive(item.path) }">
          {{ item.name }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    subNavs: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  mounted() {},
  methods: {
    computedActive(path) {
      const pathArr = path.split("/");
      const nowPathArr = this.$route.path.split("/");
      return pathArr[2] == nowPathArr[2];
    },
  },
};
</script>

<style lang="scss" scoped>
.subNavs {
  text-align: center;
  border-bottom: 1px solid rgb(103 105 105 / 30%);

  .in {
    display: flex;
  }

  a {
    flex-grow: 1;
  }

  .nav {
    padding: 10px 0;
    font-size: 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;

    &:hover {
      color: $theme;
      border-color: $theme;
    }
  }
  .active {
    font-weight: bold;
    color: $theme;
    border-color: $theme;
  }
}

@media (max-width: 750px) {
  .in {
    overflow: auto;
    touch-action: pan-x;

    a {
      white-space: nowrap;
    }
    .nav {
      font-size: 16px;
      padding: 10px;
    }
  }
}
</style>
